$('.backInStockTrigger').click(function(e) {
    e.preventDefault();

    var productName, productID, varientName, varientID, select;

    productName = $(this).attr('product-title');
    productID = $(this).attr('product-id');
    varientName = $(this).attr('product-varient-name');
    varientID = $(this).attr('product-varient-id');
    select = $('#BISModal').find('select#variants');

    $('#BISModal').removeClass('hidden');
    $('#BISModal #backInStockPopUp h3').text(productName);
    $('#BISModal #backInStockPopUp input#product').val(productID);
    $(select).append('<option value="'+ varientID +'">'+ varientName +'</option>');

    return false;
});

$('#backInStockPopUp form').on('submit',function(e){
    e.preventDefault();

    var email = $('#backInStockPopUp input#email').val();
    var id = $('#BISModal').find('select#variants').val();

    $.ajax({
        type : "POST",
        url : "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
        data : {
            a: "RBJ5UG",
            email: email,
            variant: id,
            platform: "api"
        },
        success  : function(data) {
            console.log(data);
            $('#BISModal #backInStockPopUp input#email').val('');
            $('#BISModal #completed_message').removeClass('hidden');
        },
        error  : function(data) {
            console.log(data);
        }
    });

});

$('#backInStockPopUp .close').click(function(e) {
    e.preventDefault();

    $('#BISModal #completed_message').addClass('hidden');
    $('#backInStockPopUp input#email').val('');
    $('#BISModal #backInStockPopUp h3').text('');
    $('#BISModal #backInStockPopUp input#email').val('');
    $('#BISModal').find('select#variants option').remove();
    $('#BISModal').addClass('hidden');

    return false;
});

$('#BISModal #completed_message a.closePopup').click(function(e) {
    e.preventDefault();

    $('#BISModal #completed_message').addClass('hidden');
    $('#backInStockPopUp input#email').val('');
    $('#BISModal #backInStockPopUp h3').text('');
    $('#BISModal #backInStockPopUp input#email').val('');
    $('#BISModal').find('select#variants option').remove();
    $('#BISModal').addClass('hidden');

    return false;
});